import { request } from '@/common/services/request';

const getAccountIds = (accountIds) => {
  if (Array.isArray(accountIds)) {
    return accountIds.filter(Boolean).join(',');
  }
  return accountIds;
};

const getQueryParams = (params = {}) =>
  Object.fromEntries(
    Object.entries({
      accountIds: getAccountIds(params.accountIds),
      accountType: params.accountType,
      end: params.end,
      metric: params.metric,
      organizationId: params.organizationId,
      period: params.period,
      start: params.start,
    }).filter(([, value]) => value !== undefined && value !== ''),
  );

export async function queryTraceAnalysis(params) {
  const result = await request('/api/trace/tenant/analysis', {
    method: 'GET',
    params: getQueryParams(params),
  });
  return result.data || {};
}

export async function queryTraceContentTrend(params) {
  const result = await request('/api/trace/tenant/analysis/content-trend', {
    method: 'GET',
    params: Object.fromEntries(
      Object.entries({
        accountId: params?.accountId,
        accountType: params?.accountType,
        contentId: params?.contentId,
        organizationId: params?.organizationId,
        platform: params?.platform,
      }).filter(([, value]) => value !== undefined && value !== ''),
    ),
  });
  return result.data || {};
}
